require('./RAInput.scss');
require('./RAInput.override.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

//@components
const { AmountInput } = require('commonsComponents/amountInput');
const { FormattedText, getLanguage } = require('core/i18n').i18n;

//@helpers
const CurrencyHelper = require('utilities/currencyHelper');

class RAInput extends React.Component {
    render() {
        const {
            amount,
            customClassName,
            onhandleChange,
            min,
            max,
            name,
            showRange,
            maxBackEndFractionLength,
            showBlurZero,
            disabled,
            error,
            errorMsg,
        } = this.props;

        let rangeElement;

        if (showRange) {
            const minOk = CurrencyHelper.formatAmount(min, null, 0);
            const maxOk = CurrencyHelper.formatAmount(max, null, 0);
            rangeElement = (
                <div className="ra-input__range-indicator">
                    <span>
                        <FormattedText
                            value="raInput-rangeMin"
                            injectedStrings={[minOk]}
                        />
                    </span>
                    <span> / </span>
                    <span>
                        <FormattedText
                            value="raInput-rangeMax"
                            injectedStrings={[maxOk]}
                        />
                    </span>
                </div>
            );
        }

        const raInputClass = showRange
            ? 'ra-input ra-input__range'
            : 'ra-input';
        const className = classnames(raInputClass, {
            [customClassName]: customClassName,
        });

        return (
            <div className={className}>
                <AmountInput
                    amount={amount}
                    callback={onhandleChange}
                    showBlurZero={showBlurZero}
                    min={min}
                    max={max}
                    maxBackEndFractionLength={maxBackEndFractionLength}
                    name={name}
                    overrideUI
                    disablePaste
                    language={getLanguage()}
                    disabled={disabled}
                    error={error}
                    errorMsg={errorMsg}
                />
                {rangeElement}
            </div>
        );
    }
}

RAInput.propTypes = {
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    customClassName: PropTypes.string,
    onhandleChange: PropTypes.func.isRequired,
    maxBackEndFractionLength: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    name: PropTypes.string,
    showBlurZero: PropTypes.bool,
    showRange: PropTypes.bool,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
};

RAInput.defaultProps = {
    showRange: false,
    maxBackEndFractionLength: 0,
};

module.exports = RAInput;
